import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCreateOrUpdateRechnungsempfaengerMutation, useDeleteRechnungsempfaengerMutation, useGetRechnungsempfaengerMutation } from '../../../api/StammdatenAPI';
import { IRechnungsempfaenger } from '../../../types/Types';
import LandingpageHeader from '../../header/LandingpageHeader';
import styles from '../admin.module.scss';

const emptyDto: IRechnungsempfaenger = {
  uid: '',
  name1: '',
  name2: '',
  name3: '',
  strasse: '',
  plz: '',
  ort: ''
}

export default function RechnungsempfaengerDetail() {
  const { t } = useTranslation();

  const [isLoaded, setLoaded] = useState<boolean>(false);
  const [daten, setDaten] = useState<IRechnungsempfaenger>(emptyDto);

  const [getDatenAPI] = useGetRechnungsempfaengerMutation();

  const [deleteRechnungsempfaengerApi] = useDeleteRechnungsempfaengerMutation();
  const [createOrUpdateRechnungsempfaengerAPI] = useCreateOrUpdateRechnungsempfaengerMutation();

  const navigate = useNavigate();
  const location = useLocation();

  const init = () => {

    if (location.state.view === 'detail') {
      getDatenAPI(location.state.id)
        .unwrap()
        .then((e) => {
          setDaten(e);
          setLoaded(true);
        })
        .catch((ee) => console.log(ee))

    } else if (location.state.view === 'create') {
      setDaten(emptyDto)
      setLoaded(true);
    }
  }

  const handleDelete = (e: { preventDefault: () => void; target: any; }) => {
    e.preventDefault();
    if (window.confirm('Sind sie sicher den Datensatz löschen zu wollen?')) {
      deleteRechnungsempfaengerApi(daten!.uid).unwrap()
        .then(() => navigate('/admin/rechnungsempfaenger/'))
        .catch((ee) => console.log(ee))
    }
  }

  const handleSubmit = (e: { preventDefault: () => void; target: any; }) => {
    e.preventDefault();

    if (location.state.view === 'detail' || location.state.view === 'create') {

      if (location.state.view === 'detail') {

        createOrUpdateRechnungsempfaengerAPI({
          uid: daten!.uid,
          name1: daten.name1,
          name2: daten.name2,
          name3: daten.name3,
          strasse: daten.strasse,
          plz: daten.plz,
          ort: daten.ort
        })
          .then(resp => navigate('/admin/rechnungsempfaenger/'))
          .catch((ee) => console.log(ee))
      }

      if (location.state.view === 'create') {

        createOrUpdateRechnungsempfaengerAPI({
          uid: daten!.uid,
          name1: daten.name1,
          name2: daten.name2,
          name3: daten.name3,
          strasse: daten.strasse,
          plz: daten.plz,
          ort: daten.ort
        })
          .then(resp => navigate('/admin/rechnungsempfaenger/'))
          .catch((ee) => console.log(ee))
      }

    }
  }

  const changeit = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDaten((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  /*const changeitselect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setDaten((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }*/

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <div className={classNames(styles.centerContainer)}>

        <LandingpageHeader />

        <div className='container' >

          <button
            onClick={() => {
              navigate("../", {
                relative: "path"
              });
            }}

            style={{ marginBottom: "20px" }}
            className=' btn btn-outline-primary'
          ><i className="bi bi-arrow-left"></i> {t('deTranslation.misc.backButton')}
          </button>


          <div className={styles['wg-detail-ueb']}>
            <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>Rechnungsempfänger Detail</span></div>
            <div style={{ textAlign: "end" }}></div>
          </div>

          <form onSubmit={handleSubmit} className={styles["wg-detail-form"]} >
            {(isLoaded && daten !== undefined &&
              <>
                <div className={styles['wg-detail-form-ueb']}>
                  <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>{daten?.uid}</span></div>
                  <div style={{ textAlign: "end" }}>{(location.state.view === 'detail' && <button type="button" className={styles["wg-a"]} onClick={handleDelete}><i className="bi bi-trash"></i></button>)}</div>
                </div>

                <div className={styles["wg-detail-grid-2"]}>
                  <div><label className={styles['wg']}>Name 1</label><input type="text" className={styles['wg-input-text']} name="name1" value={daten?.name1} onChange={changeit} /></div>
                  <div></div>
                  <div></div>
                </div>

                <div className={styles["wg-detail-grid-2"]}>
                  <div><label className={styles['wg']}>Name 2</label><input type="text" className={styles['wg-input-text']} name="name2" value={daten?.name2} onChange={changeit} /></div>
                  <div></div>
                  <div></div>
                </div>

                <div className={styles["wg-detail-grid-2"]}>
                  <div><label className={styles['wg']}>Name 3</label><input type="text" className={styles['wg-input-text']} name="name3" value={daten?.name3} onChange={changeit} /></div>
                  <div></div>
                </div>

                <div className={styles["wg-detail-grid-2"]}>
                  <div><label className={styles['wg']}>Strasse</label><input type="text" className={styles['wg-input-text']} name="strasse" value={daten?.strasse} onChange={changeit} /></div>
                  <div></div>
                </div>

                <div className={styles["wg-detail-grid-2"]}>
                  <div><label className={styles['wg']}>PLZ</label><input type="text" className={styles['wg-input-text']} name="plz" value={daten?.plz} onChange={changeit} /></div>
                  <div></div>
                </div>

                <div className={styles["wg-detail-grid-2"]}>
                  <div><label className={styles['wg']}>Ort</label><input type="text" className={styles['wg-input-text']} name="ort" value={daten?.ort} onChange={changeit} /></div>
                  <div></div>
                  <div style={{ textAlign: "end" }}><input type="submit" value="Speichern" className={styles['wg-btn']} /></div>
                </div>

              </>)}
          </form>


        </div>
      </div>
    </>
  );
}